import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Gender.css';

const Gender = ({ updateUserData }) => {
    const navigate = useNavigate();

    const handleClick = (gender) => {
        updateUserData({ gender });
        navigate('/age');
    };

    return (
        <div  className='r1'>
            <h2>LET'S GET STARTED</h2>
            <div className="game">
                <div className="gender-option" onClick={() => handleClick('male')}>MALE</div>
                <div className="gender-option" onClick={() => handleClick('female')}>FEMALE</div>
            </div>
        </div>
    );
};

export default Gender;
